import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/antd.min.css';
// Only DateRangePicker is used from rsuite, so we ship just its stylesheet
// instead of the full ~850KB bundle (whose global reset also fights antd).
import 'rsuite/DateRangePicker/styles/index.css';
// import './assets/font/icon.css';

import './index.css';
import './theme.css';
import { ConfigProvider } from 'antd';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import RouterMain from './routes';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Fragment>
    <Provider store={store}>
      <ConfigProvider>
        <RouterMain />
      </ConfigProvider>
    </Provider>
  </React.Fragment>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
